'use strict';

module.exports = {
    HTTP_URL: 'http://a.tiles.mapbox.com/v4',
    HTTPS_URL: 'https://a.tiles.mapbox.com/v4',
    FORCE_HTTPS: false,
    REQUIRE_ACCESS_TOKEN: true
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/mapbox.js/src/config.js
 ** module id = 943
 ** module chunks = 0 1 3 4 5 6
 **/